import React, { useEffect, useState } from 'react'
import Button from '../buttons/Button'
import npsFeedbackQuestion from '../../assets/data/npsFeedbackQuestions.json'
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateUserData } from '../../services/userDataService';
import ReactGA from "react-ga4";

const number = [1, 2, 3, 4, 5];
const numbersValue = ["Not unlikely", "Unlikely", "Maybe", "Likely", "Highly likely"]

const NpsFeedback = ({ onClose }) => {
    const dispatch = useDispatch();
    const updateUserData = useUpdateUserData();

    const { userDataLoading, userDataError, userData } = useSelector((state) => state.auth);

    const [loading, setLoading] = useState(false)
    const [npsFeedbackRatings, setNpsFeedbackRatings] = useState({
        feedback1: 0,
        feedback2: 0,
        feedback3: 0,
    });

    const handleRating = (key, rating) => {
        setNpsFeedbackRatings((prevRatings) => ({
            ...prevRatings,
            [key]: rating,
        }));
    };

    const calculateAverageRating = (ratings) => {
        const values = Object.values(ratings);
        if (values.length === 0) return 0;
        const sum = values.reduce((acc, rating) => acc + rating, 0);
        const average = sum / values.length;
        return Math.round(average);
    };

    const npsFeedbackSubmit = async () => {
        setLoading(true)
        const feedbackData = {
            email: userData.email,
            username: userData.username,
            feedback1: npsFeedbackRatings.feedback1,
            feedback2: npsFeedbackRatings.feedback2,
            feedback3: npsFeedbackRatings.feedback3,
            rating: calculateAverageRating(npsFeedbackRatings),
        };

        // Check if any feedback has been updated
        const isFeedbackUpdated =
            npsFeedbackRatings.feedback1 !== userData.feedback1 ||
            npsFeedbackRatings.feedback2 !== userData.feedback2 ||
            npsFeedbackRatings.feedback3 !== userData.feedback3;

        const isFeedbackEmpty = feedbackData.feedback1 === 0 || feedbackData.feedback2 === 0 || feedbackData.feedback3 === 0;

        if (isFeedbackEmpty) {
            setLoading(false);
            return;
        }

        try {
            const response = await updateUserData(feedbackData)
            ReactGA.gtag('event', 'nps_feedback', {
                action: 'NPS feedback submitted',
                label: 'NPS feedback submitted'
            });

            setLoading(false);
            onClose();
        } catch (error) {
            setLoading(false);
            onClose();
        }
    }


    useEffect(() => {
        if (userData) {
            setNpsFeedbackRatings({
                feedback1: userData.feedback1 || 0,
                feedback2: userData.feedback2 || 0,
                feedback3: userData.feedback3 || 0,
            });
        }
    }, [userData]);


    const npsFeedbackNumbers = ({ feedbackKey, selected }) => {
        return (
            <div className="h-[60px] flex items-center justify-between">
                {number.map((num, i) => {
                    const isSelected = num === selected;
                    return (
                        <div
                            key={i}
                            className={`text-[13px] text-text-primary rounded-[8px] cursor-pointer`}
                            onClick={() => handleRating(feedbackKey, num)}
                        >
                            <div className="flex flex-col items-center gap-[12px]">
                                <span className={`h-[32px] w-[34px] flex justify-center items-center border border-[#DBDFE5] rounded-[4px] ${isSelected ? "bg-[#E4E9FA]" : "hover:bg-[#F2F5FD]"}`}>
                                    {num}
                                </span>
                                <span>{numbersValue[i]}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className='h-[660px] w-[542px] flex flex-col'>
            <div className="h-[96px] pt-[40px] pb-[24px] px-[24px] border-b">
                <h5 className="h-[32px] text-[28px] font-semibold">
                    Help us get better
                </h5>
            </div>
            <div className="flex-grow px-[40px] py-[24px] overflow-y-scroll">
                <div className='max-w-[435px] flex flex-col gap-[40px]'>
                    {npsFeedbackQuestion.map((question, index) => {
                        const feedbackKey = `feedback${index + 1}`;

                        return (
                            <div key={index} className="flex flex-col gap-[16px] ">
                                <span className='text-cus_primary font-helveticaText-Medium font-[500] leading-[24px] tracking-[-0.02em]'>{question}</span>
                                <div className=''>
                                    {npsFeedbackNumbers({ feedbackKey, selected: npsFeedbackRatings[feedbackKey] })}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='h-[112px]'>
                <div className="flex  gap-[16px] px-10 pt-6 pb-10 border-t">
                    <Button onClick={onClose} label='Cancel' className="bg-gray-light hover:bg-gray-hoverLight text-cus_primary " />
                    <Button onClick={npsFeedbackSubmit} disabled={loading} label='Share feedback' className={`bg-blue-primary hover:bg-blue-dark text-white  ${loading && 'opacity-[50%]'}`} />
                </div>
            </div>
        </div>
    )
}

export default NpsFeedback